(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('CampaignService', CampaignService);

  CampaignService.$inject = ['$resource'];

  function CampaignService ($resource) {
    return $resource(apiUrl + '/campaign/:id', { id: '@id' }, {
      getLatest: { url: apiUrl + '/campaign/get-latest', method: 'POST', params: {}, isArray: false },
      getImportedFileUrl: { url: apiUrl + '/campaign/get-imported-file', method: 'POST', params: {}, isArray: false },
      getAll: { url: apiUrl + '/campaign/get-all', method: 'POST', params: {}, isArray: false },
      genericReport: { url: apiUrl + '/campaign/genericReport', method: 'POST', param: {}, isArray: false },
      readFile: { url: apiUrl + '/campaign/read-file', method: 'POST', params: {}, isArray: false },
      loadChannels: { url: apiUrl + '/campaign/load-channels', method: 'POST', params: {}, isArray: false },
      save: { url: apiUrl + '/campaign/save', method: 'POST', params: {}, isArray: false },
      create: { method: 'POST', params: {}, isArray: false },
      checkCampaign: { url: apiUrl + '/check-campaign', method: 'GET', params: {}, isArray: false }
    });
  }
})();
